import { Box, Tooltip, palette } from "@minervaproject/fds";
import clsx from "clsx";
import React from "react";

export type CircleButtonProps = {
  ariaLabel?: string;
  className?: string;
  disabled?: boolean;
  mode?: "dark" | "red" | "blue" | "transparent";
  onClick?: () => void;
  title?: string;
  //  Only ONE of IconComponent or Icon should be used, not both
  IconComponent?: React.ElementType;
  Icon?: React.ReactNode;
  iconColor?: string;
  tooltip?: React.ReactNode;
};

function CircleButton({
  ariaLabel,
  className,
  disabled,
  mode = "dark",
  onClick,
  title,
  IconComponent,
  Icon,
  iconColor,
  tooltip,
}: CircleButtonProps) {
  const circleButtonClassName = `circle-button--${mode}`;

  const contents = (
    <button
      className={clsx(className, circleButtonClassName)}
      title={title}
      aria-label={ariaLabel}
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      {IconComponent && <IconComponent color={iconColor || palette.blackTint20} />}
      {Icon}
    </button>
  );

  return (
    <Box mx={1}>
      {tooltip ? (
        <Tooltip backgroundColor={palette.blackTint20} iconComponent={contents}>
          <div style={{ maxWidth: "160px" }}>{tooltip}</div>
        </Tooltip>
      ) : (
        contents
      )}
    </Box>
  );
}

export { CircleButton };
